/**
 * CorpTrendChart — 12-week line trend chart for selected campus.
 */

import { useMemo } from 'react';
import LineTrendingChart from '../../../../components/charts/LineTrendingChart.jsx';

const KPI_LABELS = { response: 'Response Time', daily: 'Daily Events', total: 'Total Events' };
const KPI_FIELDS = { response: 'avg_response_time', daily: 'avg_daily_events', total: 'total_events' };

const CorpTrendChart = ({ campusData, weeks, kpi, campusName }) => {
    const chartProps = useMemo(() => {
        if (!campusData) return null;
        const field = KPI_FIELDS[kpi] || 'avg_response_time';

        // Build labels from weeks
        const labels = [];
        for (let i = 1; i <= 12; i++) {
            const start = weeks?.[`week${i}_start`] || '';
            const end = weeks?.[`week${i}_end`] || '';
            labels.push(start && end ? `${start}–${end}` : `W${i}`);
        }

        // Extract values — field format is {kpiField}_{weekNumber} (e.g. avg_response_time_1)
        const values = [];
        for (let i = 1; i <= 12; i++) {
            values.push(campusData[`${field}_${i}`] ?? null);
        }

        return { labels, values };
    }, [campusData, weeks, kpi]);

    if (!chartProps) {
        return (
            <div className="md-section">
                <h3 className="md-section__title">Select a campus to view trends</h3>
            </div>
        );
    }

    return (
        <div className="md-section">
            <h3 className="md-section__title" style={{ marginBottom: 'var(--space-4)' }}>
                {KPI_LABELS[kpi] || 'Trends'} {campusName ? `— ${campusName}` : ''} (Last 12 Weeks)
            </h3>
            <div className="md-chart-container">
                <LineTrendingChart
                    style={{ maxHeight: '350px' }}
                    x_axis={true} x_axis_title="Weeks"
                    line_axis={true} line_axis_title={KPI_LABELS[kpi] || ''}
                    lines={1}
                    line_color={['#0081C7']}
                    line_labels={[campusName || 'Campus']}
                    line_data={[chartProps.values]}
                    forceAspect={true}
                    labels={chartProps.labels}
                />
            </div>
        </div>
    );
};

export default CorpTrendChart;
